import { render, staticRenderFns } from "./organization-data-category-form.vue?vue&type=template&id=1af8ab52"
import script from "./organization-data-category-form.vue?vue&type=script&lang=js"
export * from "./organization-data-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports